//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Drawer from '@/components/drawer';
import { CosMixin } from '@/mixins/cos';
import {cloneDeep, merge} from 'lodash';

const defaultForm = {
  name: '',
  source_id: '',
  source_url: '',
  tags: [],
  category: [],
  enabled: true,
  exp_time: new Date(2099, 11, 31, 23, 59, 59),
};

// function parseJson(str, defaultValue) {
//   try {
//     return JSON.parse(str);
//   } catch (e) {
//     return defaultValue;
//   }
// }

// function numberValidator(rule, value, callback) {
//   if(isNumber(value)) {
//     callback();
//   } else {
//     callback('必须为数字');
//   }
// }

export default {
  name: 'EditAgentAppDetail',
  components: { Drawer },
  props: {
    row: {type: Object, default: () => {} },
    type: {type: String, default: 'create' },
    visible: {
      type: Boolean,
      default: false,
    },
    isUploadType: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [CosMixin],
  data() {
    return {
      form: cloneDeep(defaultForm),
      dataset: {},
      inputVisible: false,
      inputValue: '',
      inputCategoryVisible: false,
      inputCategoryValue: '',
      fileList: [],
      rules: {
        name: [
          { required: true, message: '请输入文档名称', trigger: 'blur' },
        ],
        source_id: [
          { required: true, message: '请输入数据行ID', trigger: 'blur' },
        ],
        source_url: [
          { required: true, message: '请选择上传文档', trigger: 'change' },
        ],
        exp_time: [
          { required: true, message: '请选择过期时间', trigger: 'change' },
        ],
        enabled: [
          { required: true, message: '请选择是否启用', trigger: 'change' },
        ],
      },
    };
  },
  watch: {
    visible() {
      this.$refs?.form?.clearValidate();
      if (this.visible) {
        if(this.type === 'edit') {
          this.form =merge(cloneDeep(defaultForm), this.resetData(cloneDeep(this.row)));
        } else {
          this.form = cloneDeep(defaultForm);
          this.fileList = [];
        }
        this.$nextTick(()=>{
          this.getDataset();
        });
      }
    },
  },
  mounted() {
  },
  methods: {
    close() {
      this.$emit('close');
    },
    resetData(formData) {
      formData.exp_time = formData.exp_time * 1000;
      this.fileList = formData.source_url ? [{url: formData.source_url}] : [];
      return formData;
    },
    async getDataset() {
      try {
        const { dataset } = await this.$request({
          url: this.$api.getAgentDataset,
          data: {
            id: this.$route?.query?.dataset_id,
          },
        });
        this.dataset = dataset;
      } catch (err) {
        console.log(err);
        this.objectList = [];
      }
    },

    async handleRequest(file) {
      const pattern = new RegExp(
        "[%--`~!@#$^&*()=|{}':;',\\[\\]<>/?~！@#￥……&*（）——| {}【】‘；：”“'。，、？]",
      );
      const s = file.file.name;
      let rs = '';
      for (let i = 0; i < s.length; i++) {
        rs = rs + s.substr(i, 1).replace(pattern, '');
      }
      // 截取文件类型
      const lastPointIndex = rs.lastIndexOf('.');
      const suffix = rs.substring(lastPointIndex);
      const cosParams = {
        imgCosKey: `${file.file.uid}${rs}`,
        fileObject: file.file,
        suffix,
      };
      try {
        const res = await this.putCosObjectWithPrivate(cosParams);
        this.fileList.push({
          url: res.data,
          role: null,
          package: null,
          path: null,
        });
        this.$set(this.form, 'source_url', res.data);
      } catch (err) {
        console.log(err);
        this.$message('上传失败，请稍后再试');
      }
    },
    async handleDonwoload() {
      const url = this.form.source_url;
      const publicUrl = await this.getPrivateUrl(url);
      fetch(publicUrl)
        .then(response => response.blob())
        .then(blob => {
          // 创建一个隐藏的<a>元素
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          // 将<a>元素添加到DOM中
          document.body.appendChild(link);
          // 触发点击事件
          link.click();
          // 移除<a>元素
          document.body.removeChild(link);
          // 释放URL对象
          URL.revokeObjectURL(link.href);
        })
        .catch(error => {
          console.error('下载文件时出错:', error);
        });

    },
    handleUploadRemove() {
      this.fileList = [];
      this.$set(this.form, 'source_url', '');
    },
    handleOnExceed() {
      this.$message.error('只能上传一个文件');
    },
    handleClose(tag) {
      this.form.tags.splice(this.form.tags.indexOf(tag), 1);
    },
    handleCloseCategory(category) {
      this.form.category.splice(this.form.category.indexOf(category), 1);
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick(() => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    showInputCategory() {
      this.inputCategoryVisible = true;
      this.$nextTick(() => {
        this.$refs.saveCategoryInput.$refs.input.focus();
      });
    },
    handleInputConfirm() {
      const inputValue = this.inputValue;
      if (inputValue) {
        this.form.tags.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = '';
    },
    handleInputConfirmCategory() {
      const inputCategoryValue = this.inputCategoryValue;
      if (inputCategoryValue) {
        this.form.category.push(inputCategoryValue);
      }
      this.inputCategoryVisible = false;
      this.inputCategoryValue = '';
    },
    submitForm() {
      this.$refs.form.validate((valid) => {
        // valid
        console.log('%c Line:77 🥤 valid', 'color:#ffdd4d', valid);
        if (valid) {
          const formData = cloneDeep(this.form);
          if(this.dataset.data_source_type !== 'upload') {
            formData.source_url = undefined;
          }
          if(this.dataset.data_source_type !== 'db-data') {
            formData.source_id = undefined;
          }
          formData.exp_time = parseInt(formData.exp_time / 1000);
          formData.dataset_id = formData.dataset_id ? formData.dataset_id : this.$route.query.dataset_id;
          console.log('submit data: ', formData);
          this.$request({
            url: this.type === 'edit' ? this.$api.updateAgentDocument : this.$api.createAgentDocument,
            data: this.type === 'edit' ? {
              id: formData.id,
              document: formData,
            } : formData,
          }).then((res) => {
            console.log('%c Line:154 🥕 res', 'color:#42b983', res);
          this.$emit('refresh');
          this.$message.success('保存成功');
          this.close();
          }).catch(()=>{
            this.$message.error('保存失败');
          });
        } else {
          this.$message.warning('请填写必填项');
        }
      });
    },
  },
};
